export default (props = {}) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<path d="M18.6255 9.03342H14.9097V18.75H18.6255V9.03342ZM5.375 11.3751H9.09074V18.75H5.375V11.3751ZM10.1424 5.25H13.8581V18.75H10.1424V5.25Z" fill="white"/>
</svg>
